import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackFreshPromoCardClick, trackFreshPromoListShow } from './tracking';
import { FreshPromoList } from '../../components/FreshPromoList';
import { selectPage } from '../../selectors/analytics';
import { selectNewbuildingPromos } from '../../selectors/promosPage';
import { INewbuildingPromo } from '../../types/promosPage';
import { useApplicationContext } from '../../utils/applicationContext';
import { getNewbuildingCardUrl } from '../../utils/urls';

export const FreshPromoListContainer: React.FC = () => {
  const items = useSelector(selectNewbuildingPromos);

  const { siteType } = useSelector(selectPage);
  const { config } = useApplicationContext();

  const handleListShow = React.useCallback(() => trackFreshPromoListShow(items), [items]);

  const handleCardClick = React.useCallback(
    (promo: INewbuildingPromo) => {
      trackFreshPromoCardClick(promo);

      const newbuildingCardUrl = getNewbuildingCardUrl({
        baseUrl: promo.newbuildingUrl,
        uniquePromoId: promo.uniquePromoId,
        siteType,
        config,
      });

      window.open(newbuildingCardUrl);
    },
    [siteType, config],
  );

  if (items.length === 0) {
    return null;
  }

  return (
    <FreshPromoList
      title="Новые скидки и акции"
      promoList={items}
      onListShow={handleListShow}
      onCardClick={handleCardClick}
    />
  );
};
